export default "__VITE_ASSET__qXfkzG3l__"